import {getActiveItinerary, getActiveSearch} from "../../../@opentripplanner/core-utils/src/state";
import {connect} from "react-redux";
import {useEffect} from "react";
import {getItineraryBounds, getLegBounds} from "../../../@opentripplanner/core-utils/src/itinerary";
import {isMobile} from "../../../@opentripplanner/core-utils/src/ui";

const padding = 30;

function BoundsUpdatingOverlay(props) {
  const {activeLeg, activeStep, itinerary, query, popupLocation, map, mapConfig} = props;

  useEffect(() => {
    // Don't auto-fit if popup us active
    if (popupLocation) return;
    // Fit map to to entire itinerary if active itinerary bounds changed
    const newItinBounds = itinerary && getItineraryBounds(itinerary);

    if (
      newItinBounds && map
    ) {
      map?.fitBounds(newItinBounds, { padding: padding })
      // Pan to to itinerary leg if made active (clicked); newly active leg must be non-null
    }
  }, [itinerary]);

  useEffect(() => {
    if (
      itinerary &&
      activeLeg !== null
      && map
    ) {
      let cornerBounds = getLegBounds(itinerary.legs[activeLeg]);
      map?.fitBounds(cornerBounds,
        { padding: padding }
      )
    } else if (
      itinerary &&
      activeLeg !== null &&
      activeStep !== null
      && map
    ) {
      const leg = itinerary.legs[activeLeg];
      const step = leg.steps[activeStep];

      map?.flyTo({center: [step.lon, step.lat], zoom: mapConfig.initZoom || 13, speed: 1.6});
    }
  },[activeLeg, activeStep]);

  useEffect(() => {
    const newFrom = query.from;
    const newTo = query && query.to;

    if (newFrom && newTo && map) {
      if (!isMobile()) {
        map?.fitBounds([
          [newFrom.lon, newFrom.lat],
          [newTo.lon, newTo.lat]
        ], { padding: padding })
      }

      // If only from or to is set, pan to that
    } else if (newFrom) {
      map?.flyTo({center: [newFrom.lon, newFrom.lat], zoom: mapConfig.initZoom || 13, speed: 1.6});
    } else if (newTo) {
      map?.flyTo({center: [newTo.lon, newTo.lat], zoom: mapConfig.initZoom || 13, speed: 1.6});
    }
  },[query]);


  return null;
}

const mapStateToProps = (state, ownProps) => {
  const activeSearch = getActiveSearch(state.otp);
  return {
    activeLeg: activeSearch && activeSearch.activeLeg,
    activeStep: activeSearch && activeSearch.activeStep,
    itinerary: getActiveItinerary(state.otp),
    popupLocation: state.otp.ui.mapPopupLocation,
    query: state.otp.currentQuery,
    mapConfig: state.otp.config.map,
  }
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(BoundsUpdatingOverlay)